import { render, staticRenderFns } from "./PosTenderReport.vue?vue&type=template&id=410b314b&"
import script from "./PosTenderReport.vue?vue&type=script&lang=js&"
export * from "./PosTenderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports